jQuery( function( $ ) {
	const $mobileButton = $( 'button#mobile-button' ),
		$acMenu = $( '.sisu-nav-mobile' );

	$mobileButton.on( 'click', function() {
		$( this ).parent( '.mobile-button-container' ).toggleClass( 'mobile-open' );
		$acMenu.toggleClass( 'mobile-open' );
	} );

	$( '.nav-menu > .menu-item-has-children' ).append( '<div class="toggle-sub-menu">' +
			'<svg viewBox="0 0 12 8">' +
				'<path d="M6,8C5.7,8,5.4,7.9,5.2,7.6l-5-6C-0.1,1.2,0,0.5,0.4,0.2S1.5,0,1.8,0.4l4.2,5l4.2-5c0.4-0.4,1-0.3,1.4,0.1\n' +
				'\tc0.3,0.3,0.3,0.8,0.1,1.2l-5,6C6.5,7.9,6.3,8,6,8z"/>' +
			'</svg>' +
		'</div>'
	);

	$( '.toggle-sub-menu' ).on( 'click', function() {
		if ( 992 >= window.innerWidth ) {
			$( this ).siblings( '.sub-menu' ).toggleClass( 'show-sub-menu' );
			$( this ).toggleClass( 'sub-menu-open' );
		}
	} );
} );
